"use strict";

var cov_38lbowtp0 = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/organizations/index.js";
  var hash = "1ae6feae1eb9446df2e6906770007b0385e941de";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/organizations/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "1ae6feae1eb9446df2e6906770007b0385e941de"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Organizations", {
  enumerable: true,
  get: function get() {
    return _Organizations.default;
  }
});
Object.defineProperty(exports, "CurrentUserOrganizations", {
  enumerable: true,
  get: function get() {
    return _CurrentUserOrganizations.default;
  }
});

var _Organizations = _interopRequireDefault(require("./Organizations"));

var _CurrentUserOrganizations = _interopRequireDefault(require("./CurrentUserOrganizations"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}